import {
    handleDropinError,
    processPaymentResult,
    sendBankCheckDetails,
    sendBankCheckStartForAttempt,
    startGatedPayment,
} from "./paymentPage.flow";

export function usePaymentPageDropinCallbacks(pageContextReference) {
    function handleBeforeSubmit(paymentData, component, actions) {
        startGatedPayment(pageContextReference.current, paymentData, component, actions);
    }

    function handleActionHandled() {
        sendBankCheckStartForAttempt(pageContextReference.current);
    }

    function handleAdditionalDetails(detailsState, component, actions) {
        sendBankCheckDetails(pageContextReference.current, detailsState, actions);
    }

    function handlePaymentFinished(paymentResult) {
        processPaymentResult(pageContextReference.current, paymentResult);
    }

    function handleCheckoutError(error) {
        handleDropinError(pageContextReference.current, error);
    }

    return Object.freeze({
        beforeSubmit: handleBeforeSubmit,
        onActionHandled: handleActionHandled,
        onAdditionalDetails: handleAdditionalDetails,
        onPaymentCompleted: handlePaymentFinished,
        onPaymentFailed: handlePaymentFinished,
        onError: handleCheckoutError,
    });
}
